var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AppToolbar',{attrs:{"items":_vm.navigations,"title":"Apps"},on:{"icon-click":function($event){_vm.drawer=!_vm.drawer}}}),_c('AppSidebar',{attrs:{"drawerProp":_vm.drawer,"items":_vm.navigations}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }